export var meterWidth = 280;
//# sourceMappingURL=index.js.map